import { render, staticRenderFns } from "./EventToday.vue?vue&type=template&id=3ed853fa&scoped=true"
import script from "./EventToday.vue?vue&type=script&lang=js"
export * from "./EventToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed853fa",
  null
  
)

export default component.exports